import * as React from 'react';
import { FeatureIcon } from '@grandvisionhq/icons';

const ProductDetailLensesFeatures = ({ hydration , softness , breathability , fatigue , basics , uv ,  })=>{
    if (!hydration && !softness && !breathability && !fatigue && !basics && !uv) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("ul", {
        className: "product-detail-lenses-features"
    }, basics && basics.variantHasAttribute && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--basics"
    }, /*#__PURE__*/ React.createElement(FeatureIcon, {
        name: "basics",
        size: 38
    }), basics.label), hydration && hydration.variantHasAttribute && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--hydration"
    }, /*#__PURE__*/ React.createElement(FeatureIcon, {
        name: "hydration",
        size: 38
    }), hydration.label), softness && softness.variantHasAttribute && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--softness"
    }, /*#__PURE__*/ React.createElement(FeatureIcon, {
        name: "softness",
        size: 38
    }), softness.label), breathability && breathability.variantHasAttribute && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--breathability"
    }, /*#__PURE__*/ React.createElement(FeatureIcon, {
        name: "breathability",
        size: 38
    }), breathability.label), fatigue && fatigue.variantHasAttribute && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--fatigue"
    }, /*#__PURE__*/ React.createElement(FeatureIcon, {
        name: "fatigue",
        size: 38
    }), fatigue.label), uv && uv.variantHasAttribute && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--uv"
    }, /*#__PURE__*/ React.createElement(FeatureIcon, {
        name: "uv",
        size: 38
    }), uv.label));
};

export { ProductDetailLensesFeatures };
//# sourceMappingURL=ProductDetailLensesFeatures.js.map
